import template from './finance-group-about.pug';

export const FinanceGroupAboutComponent = {
  template,
  bindings: {
    onAddNew: '&'
  },
  transclude: true,
  controller: class FinanceGroupAboutComponent {
    constructor() {
      'ngInject';
    }

    $onInit() {
    }
  }
};
